export default __webpack_public_path__ + "static/media/argon-dashboard-react.css.17c23ef5.map";